import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { differenceInDays } from 'date-fns';
import convertToCurrency from '../../../../../_shared/utils/convertToCurrency';
import copyToClipBoard from '../../../../../_shared/utils/copyToClipBoard';
import Alert from '../../../../../_shared/components/Alert';
import { StyledLabel, StyledRow, StyledValue } from './Styles';
import CopyToClipboard from '../../../../../_shared/components/CopyToClipboard';
import theme from '../../../../../_shared/themes';
import TRToast from '../../../../../_shared/helpers/TRToast';

const ListContentPaymentsOnHold = ({ trade = {} }) => {
  const { vin, bidPlacedTime, topBid } = trade;
  const intl = useIntl();
  const now = new Date();
  const bidTime = new Date(bidPlacedTime);
  const bidPlacedDaysAgo = differenceInDays(now, bidTime);

  const copyToClipBoardHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    copyToClipBoard(vin);
    TRToast(
      <Alert
        variant="information"
        messages={[<FormattedMessage id="vdp.success.vinCopied" />]}
      />
    );
  };

  return (
    <>
      <StyledRow>
        <StyledLabel>VIN:</StyledLabel>
        <CopyToClipboard
          label={vin ? vin.toUpperCase() : ''}
          icon="TR5-Copy_to_clipboard"
          testId="vinCopyButton"
          fontSize={theme.FONT_SIZES.SMALL}
          onClick={copyToClipBoardHandler}
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>
          <FormattedMessage id="paymentsOnHold.soldFor" />:
        </StyledLabel>
        <StyledValue>{convertToCurrency(topBid || 0)}</StyledValue>
      </StyledRow>
      <StyledRow>
        {/* [TODO] Requires Translation */}
        <StyledLabel>
          In{' '}
          {intl.formatMessage({
            id: 'vdp.bid.tradeState.arrived'
          })}
          :
        </StyledLabel>
        <StyledValue>
          <FormattedMessage
            id="vdp.bid.placedDaysAgo"
            values={{ daysAgo: bidPlacedDaysAgo }}
          />
        </StyledValue>
      </StyledRow>
    </>
  );
};

export default ListContentPaymentsOnHold;
